import { useInstructionsScript } from 'hooks/useInstructionsScript';
import PropTypes from 'prop-types';
import { EmbeddedRepository } from 'repositories/embedded/embedded';
import { RedirectUrl } from 'utils';
import './EmailInstructions.scss';
import { Button } from 'components/ui/Button/Button';

const DEFAULT_PAYMENT_STATUS = 'initiated';

function redirectToExternalUrl({ url, id }) {
  const returnUrlWithId = RedirectUrl.build(url, id, DEFAULT_PAYMENT_STATUS);
  const onFinish = EmbeddedRepository.getProp('fwFinish');

  onFinish(returnUrlWithId.toString());
}

function EmailInstructions({
  embeddedScript,
  i18n,
  locale,
  publicKey,
  scriptSignature,
  returnUrl,
  paymentId,
}) {
  useInstructionsScript({ embeddedScript, publicKey, scriptSignature });

  return (
    <>
      <div
        data-testid="onlineInstructions"
        id="payment"
        className="EmbeddedScript"
        data-locale={locale}
      ></div>
      <Button
        className="marginTop-xl Offline-Redirect-Button"
        tone="primary"
        size="full"
        onClick={() => redirectToExternalUrl({ url: returnUrl, id: paymentId })}
      >
        {i18n.t('online.email.redirectionButton')}
      </Button>
    </>
  );
}

EmailInstructions.propTypes = {
  embeddedScript: PropTypes.object,
  i18n: PropTypes.shape({ t: PropTypes.func.isRequired }),
  locale: PropTypes.string,
  paymentId: PropTypes.string,
  publicKey: PropTypes.string,
  returnUrl: PropTypes.string,
  scriptSignature: PropTypes.object,
};

export { EmailInstructions };
